import React from "react";

const Header = () => {
  return (
    <div className="Header">
      <h1 className="title">WebCam Based Rock-Paper-Scissor</h1>
    </div>
  );
};

export default Header;
